import { useTranslation } from 'react-i18next';
import React from 'react'
import { Button } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/erp_subpackage/components/YhBox'
import { useAllocModel } from "../inventoryStatisticsModel";

export const DataBox = () => {
    const { t } = useTranslation();
    const { exportOut } = useAllocModel()

    const action = (
        <>
            <Button
                className="btn-item"
                type="link"
                shape="round"
                onClick={() => {
                    exportOut()
                }}
            >
                {t(`stock.view.DataBox.导出`)}
            </Button>
        </>
    )

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}
